import { Polygon } from "geojson";
import { z } from "zod";

import { fetchWithError } from "@nens/react-query-utils";
import { combineUrlAndParams, polygonToEwkt } from "@nens/shared-utils";

const rasterDataSchema = z.object({
  task_id: z.string(),
  url: z.string(),
});

export type RasterData = z.infer<typeof rasterDataSchema>;

export async function fetchRasterData(
  uuid: string,
  geometry: Polygon,
  pixelSize: number,
  projection: string,
  noDataValue: string,
  start?: string
) {
  // nodata value is of type float, e.g. 10.0
  const nodata = noDataValue.includes(".")
    ? noDataValue
    : noDataValue
    ? parseFloat(noDataValue).toFixed(1)
    : "";
  const geom = polygonToEwkt(geometry);
  const url = combineUrlAndParams(`/api/v4/rasters/${uuid}/data/`, {
    format: "geotiff",
    geom,
    projection,
    pixel_size: pixelSize,
    async: true,
    ...(nodata && { nodata }),
    ...(start && { start }),
  });

  const json = await fetchWithError(url, {
    headers: {
      Accept: "*/*",
    },
  });
  return rasterDataSchema.parse(json);
}
